import React from "react";

// Default decorative photos baked into the Webflow design. Each card slot
// can be overridden by a couple-uploaded image via the `images` prop (array
// of presigned URLs, indexed positionally). Empty / missing → keep default.
const DEFAULT_CARDS = [
  { image: "/assets/img/auto_001.jpg", label: "" },
  { image: "/assets/img/place.jpg", label: "" },
  { image: "/assets/img/venue.jpg", label: "" },
];

const ExperienceCollectionCards = ({ images }) => {
  const cards = DEFAULT_CARDS.map((card, idx) => ({
    ...card,
    image: (images && images[idx]) || card.image,
  }));

  return (
    <div className="home-col-wrapper _70-bottom w-dyn-list">
      <div role="list" className="home-col-list w-dyn-items">
        {cards.map((card, index) => (
          <div key={index} role="listitem" className="home-col-item w-dyn-item">
            <div className="card-link w-inline-block">
              <div className="col-im-link">
                <div
                  style={{ backgroundImage: `url('${card.image}')` }}
                  className="card-im"
                ></div>
              </div>
              {card.label ? (
                <>
                  <div className="card-txt-link">
                    <div>{card.label}</div>
                    <div className="ball"></div>
                  </div>
                </>
              ) : undefined}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExperienceCollectionCards;
